const SUPPORTED_RULES = new Set([
  "alpha",
  "alpha-dash",
  "alpha-num",
  "between",
  "confirmed",
  "credit-card",
  "digits",
  "email",
  "file",
  "fileType",
  "host_port",
  "integer",
  "ip",
  "length",
  "max",
  "max_value",
  "min",
  "min_value",
  "month_day_format",
  "numeric",
  "password",
  "positive",
  "regex",
  "required",
  "requiredArray",
  "required_duration",
  "required_if",
  "url",
]);

export function sanitizeCommandFieldRules(rules) {
  if (typeof rules !== "string" || rules === "") {
    return rules;
  }
  return rules
    .split("|")
    .filter((rule) => SUPPORTED_RULES.has(rule.split(":")[0].trim()))
    .join("|");
}

export default sanitizeCommandFieldRules;
